export const RESET = 'COUNTRY_LIST_RESET'
export const SET_ITEMS = 'COUNTRY_LIST_SET_ITEMS'
export const SET_ERROR = 'COUNTRY_LIST_SET_ERROR'
export const SET_VIEW = 'COUNTRY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'COUNTRY_LIST_TOGGLE_LOADING'
